import React, { useState, useEffect } from 'react';
import { loadingImage } from '../auth';

import ADMIN_HOURS_DATA, { ADMIN_CATEGORIES, ADMIN_DEFAULTS } from "./adminHoursData";
import { q3gRate, q3gWeekKey } from './q3gRates';
const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const DEPTS = [
  { id: 'pid', name: 'PID', volKey: 'pid', functions: [
    { casual: 'PID Unload', fn: 'Vendor Line Load' },
    { casual: 'PID Divert', fn: 'PID Manual Divert' },
    { casual: 'PID Inject', fn: 'Receive Line Loader' },
    { casual: 'PID Operator', fn: 'Receive Dock Crew' },
  ]},
  { id: 'aros', name: 'AROS', volKey: 'aros', functions: [
    { casual: 'AROS Unload', fn: 'ReceiveLine Unloader' },
    { casual: 'AROS Operator', fn: 'Receive Dock Crew' },
    { casual: 'AROS CSX Label', fn: 'PID Sort Line' },
    { casual: 'AROS Avery', fn: 'MHE Support' },
    { casual: 'AROS Divert', fn: 'Robotic Problem Solv' },
    { casual: 'IDRT AROS', fn: '__IDRT_AROS__' },
    { casual: 'AROS Waterspider', fn: 'Robotic Water Spider' },
  ]},
  { id: 'ibPR', name: 'IB PR', volKey: 'pr', functions: [
    { casual: 'PR Unload', fn: 'Vendor Sort' },
    { casual: 'Pallet Build', fn: 'Offline_Mods' },
    { casual: 'Pallet Wrap/Lantech', fn: 'IB Robotics Operator' },
    { casual: 'PR Waterspider', fn: 'Rcv WaterSpider' },
    { casual: 'IB Pallet EPJ WS', fn: 'Case Rcv WaterSpider' },
    { casual: 'Pallet Auditors', fn: 'General Audits' },
  ]},
  { id: 'ibPIT', name: 'IB PIT', volKey: 'skid', functions: [
    { casual: 'PIT Pallet Build', fn: 'ReceiveParcel Unload' },
    { casual: 'IB PIT Waterspider', fn: 'Vendor Cutter' },
    { casual: 'PIT Unloader', fn: 'PID Truck Unload' },
  ]},
  { id: 'sorterEOL', name: 'Sorter EOL', volKey: 'eol', functions: [
    { casual: 'EOL Avery', fn: 'Tote Replenishment' },
    { casual: 'EOL Divert', fn: 'Transfer Out Kaizen' },
    { casual: 'IDRT EOL', fn: '__IDRT_EOL__' },
    { casual: 'EOL Waterspider', fn: 'Water Spider' },
  ]},
  { id: 'fluid', name: 'Fluid', volKey: 'fluidTotal', functions: [
    { casual: 'Fluid WS', fn: 'Transfer Out Packing' },
    { casual: 'Fluid Load', fn: 'Fluid Load - Case' },
    { casual: 'Sorter Wallbuilder', fn: 'Wall Builder' },
    { casual: 'Wall Builder', fn: 'Robotics Operator' },
    { casual: 'Jam Clear', fn: 'MHE Support' },
  ]},
  { id: 'obPR', name: 'OBPR', volKey: 'obPR', functions: [
    { casual: 'OB EPJ WaterSpider', fn: 'Outbound Dock Crew' },
    { casual: 'Pallet Loader', fn: 'Dock Pallet Loader' },
    { casual: 'OB PIT Operator', fn: 'Truck Loader' },
    { casual: 'OB EPJ Operator', fn: 'IXD Pallet Loader' },
  ]},
  { id: 'ibSupport', name: 'IB Support', volKey: 'ibCartons', functions: [
    { casual: 'IB Problem Solve', fn: 'Receive ProblemSolve' },
    { casual: 'IB Lead/PA', fn: 'Receive Lead/PA' },
    { casual: 'IB TDR', fn: 'Receive Dock TDR' },
    { casual: 'IB Clerk', fn: 'Inbound Dock Clerk' },
    { casual: 'LP Receive', fn: '_line_lpReceive' },
    { casual: 'Pallet Receive', fn: '_line_palletReceive' },
    { casual: 'Each Receive', fn: '_line_eachReceiveSmall' },
    { casual: 'Prep Receive', fn: '_line_prepRecorderSmall' },
  ]},
  { id: 'obSupport', name: 'OB Support', volKey: 'daCartons', functions: [
    { casual: 'DA Problem Solve', fn: 'TransferOut PSolve' },
    { casual: 'DA Lead/PA', fn: 'Transfer Out Lead/PA' },
    { casual: 'OB Training', fn: 'TransferOut Training' },
    { casual: 'OB Ambassador', fn: 'Transfer Out Ambssdr' },
    { casual: 'Ship Clerk', fn: 'Ship Clerk' },
    { casual: 'OB TDR', fn: 'TransferOut DockCrew' },
    { casual: 'Trans Out Overflow', fn: 'Trans Out Overflow' },
  ]},
];

const FN_CARTON_MAP = {
  'Vendor Line Load': 'pid', 'PID Manual Divert': 'pid', 'Receive Line Loader': 'pid', 'Receive Dock Crew': 'pid',
  'ReceiveLine Unloader': 'aros', 'PID Sort Line': 'aros',
  'MHE Support': 'pid',
  'Robotic Problem Solv': 'aros', 'Jackpot Kickout': 'aros', 'Robotic Water Spider': 'aros',
  '__IDRT_EOL__': 'eol', '__IDRT_AROS__': 'aros',
  'Vendor Sort': 'pr', 'Offline_Mods': 'pr', 'IB Robotics Operator': 'pr',
  'Rcv WaterSpider': 'pr', 'Case Rcv WaterSpider': 'pr', 'General Audits': 'pr',
  'ReceiveParcel Unload': 'pr', 'Vendor Cutter': 'pr', 'PID Truck Unload': 'pr',
  'Tote Replenishment': 'eol', 'Transfer Out Kaizen': 'eol', 'Water Spider': 'eol',
  'Wall Builder': 'fluidDirect', 'Robotics Operator': 'fluidOffline', 'Transfer Out Packing': 'fluidOffline', 'Fluid Load - Case': 'fluidOffline',
  'Outbound Dock Crew': 'daCartons', 'Dock Pallet Loader': 'pr', 'Truck Loader': 'daCartons', 'IXD Pallet Loader': 'pr',
  'Receive Dock TDR': 'ibCartons', 'Inbound Dock Clerk': 'ibCartons', 'Receive ProblemSolve': 'ibCartons', 'Receive Lead/PA': 'ibCartons',
  'TransferOut Training': 'daCartons', 'Transfer Out Ambssdr': 'daCartons', 'Ship Clerk': 'daCartons', 'TransferOut DockCrew': 'daCartons', 'TransferOut PSolve': 'daCartons', 'Transfer Out Lead/PA': 'daCartons',
  'TO Lead/PA': 'daCartons', 'TO Problem Solve': 'daCartons',
  'Trans Out Overflow': 'daCartons',
};

// Dept-aware carton-volume override, keyed 'deptId|fn'. Resolves the shared
// 'Offline_Mods' function name, which means Pallet Build (IB PR -> 'pr' cartons)
// under the ibPR dept but EOL Sort (-> 'eol' cartons) under the sorterEOL dept.
// FN_CARTON_MAP is keyed by fn name alone and can't distinguish them, so it maps
// Offline_Mods to 'pr' — which wrongly forced EOL Sort's planned volume to Pallet
// cartons. This override takes precedence in getFnHours so EOL Sort plans off EOL
// cartons at the EOL-sort rate, while Pallet Build stays on 'pr'. (Planning stays
// per-path: EOL sort = eol/EOL-rate, AROS sort = aros/AROS-rate; the display fuses
// them as Manual Sort.)
const FN_DEPT_CARTON_OVERRIDE = {
  'sorterEOL|Offline_Mods': 'eol',
};

// Resolves the carton-volume key for a function, honoring the dept-aware override
// first. Use this EVERYWHERE volume is resolved for a (fn, dept) so the shared
// 'Offline_Mods' name (Pallet Build -> pr, EOL Sort -> eol) stays consistent
// across getFnHours, the MEE optimizer, and the rate/hours cross-derivation UI.
const resolveFnVolKey = (fn, dept) =>
  FN_DEPT_CARTON_OVERRIDE[`${dept.id}|${fn}`] || FN_CARTON_MAP[fn] || dept.volKey;

// Per-shift planned volumes from a shiftData entry. Pure (shared with MSM so both
// tabs plan off identical volumes). PR = total - PID - AROS; SKID is planned inside PR.
export function lvpVols(entry, fppRatios, eolPct) {
  const cartons = entry?.cartons || 0;
  // Allow manual override of PID and AROS cartons
  const pidV = entry?.pidCartons !== undefined && entry?.pidCartons !== '' ? parseInt(entry.pidCartons) || 0 : Math.round(cartons * fppRatios.pid);
  const arosV = entry?.arosCartons !== undefined && entry?.arosCartons !== '' ? parseInt(entry.arosCartons) || 0 : Math.round(cartons * fppRatios.aros);
  // Pallets = total - PID - AROS
  const palletV = cartons - pidV - arosV;
  const prV = palletV > 0 ? palletV : 0;
  const skidV = 0;
  const eolV = Math.round(pidV * eolPct / 100);
  const fluidDirect = pidV - eolV;
  const fluidOffline = eolV + arosV;
  return { pid: pidV, aros: arosV, pr: prV, skid: skidV, eol: eolV, fluidDirect, fluidOffline, fluidTotal: fluidDirect + fluidOffline, ibCartons: cartons, daCartons: cartons, ib: cartons, ob: cartons, obPR: prV };
}
export { DEPTS as LVP_DEPTS, resolveFnVolKey as lvpResolveFnVolKey };

// Common Sense Flat Staffing: these functions are held at a static per-shift hours
// (4-week average) rather than scaling with planned cartons — same set as MEESA.
const FLAT_STAFF_FUNCTIONS = new Set(['Inbound Dock Clerk', 'Receive Dock TDR', 'MHE Support', 'Transfer Out Kaizen', 'Tote Replenishment', 'Ship Clerk']);

export default function LVP({ api, site }) {
  const [trailerText, setTrailerText] = useState('');
  const [fppRatios, setFppRatios] = useState({ pid: 0.5, aros: 0.07, pr: 0.35, skid: 0.08 });
  const [eolPct, setEolPct] = useState(33);
  const [cpp, setCpp] = useState(30.98);
  // Raw string for the CPP input so mid-typing states like "30." / "30.0" aren't
  // normalized away by parseFloat (lets you type 2 decimals). cpp stays numeric.
  const [cppInput, setCppInput] = useState('30.98');
  const [weekStart, setWeekStart] = useState('');
  const [saved, setSaved] = useState(false);
  const [funcRates, setFuncRates] = useState({});
  const [meesaLoaded, setMeesaLoaded] = useState(false); // B3of4 rates from MEESA

  // Per-shift data: { sunD: { hours, cartons }, sunN: { hours, cartons }, ... }
  const initShifts = () => {
    const d = {};
    DAYS.forEach(day => { d[day + '_day'] = { hours: 0, cartons: 0 }; d[day + '_night'] = { hours: 0, cartons: 0 }; });
    return d;
  };
  const [shiftData, setShiftData] = useState(initShifts);

  // Overrides: { deptId: { rate: {sunD: x}, hours: {sunD: x} }, fnName: { rate: {sunD: x}, hours: {sunD: x} } }
  const [overrides, setOverrides] = useState({});
  const [meeInfo, setMeeInfo] = useState('');
  const [flatStaffing, setFlatStaffing] = useState(false); // hold FLAT_STAFF_FUNCTIONS at a static per-shift hours
  // The LVP is the authoritative bottoms-up plan and always plans off B3of4
  // (historical best-3-of-4) rates. Q3G (Finance tops-down guidance) is shown as
  // a read-only reference row only (Q3G Target CPLH), never used to drive/scale
  // planned hours — a fresh detailed plan is built and saved each week instead.
  const [flatFnHours, setFlatFnHours] = useState({}); // { fn: 4wk-avg per-shift static hours }
  const [adminHours, setAdminHours] = useState({}); // { Sunday_day: 50, ... }
  const [adminDetail, setAdminDetail] = useState(() => JSON.parse(JSON.stringify(ADMIN_DEFAULTS))); // editable per-function values
  const [rosteredHours, setRosteredHours] = useState({});
  const defaultAttendance = { Sunday_day: 75, Monday_day: 86, Tuesday_day: 83, Wednesday_day: 83, Thursday_day: 86, Friday_day: 85, Saturday_day: 83, Sunday_night: 74, Monday_night: 85, Tuesday_night: 82, Wednesday_night: 82, Thursday_night: 85, Friday_night: 84, Saturday_night: 82 };
  const [attendanceRate, setAttendanceRate] = useState(defaultAttendance);
  const [alpsFillMsg, setAlpsFillMsg] = useState('');

  // Auto-fill the weekly Rostered Hours / Attendance % / Hours / Cartons from
  // the ALPS cache (ALPS_<site>), replacing the manual ALPS->CSV upload.
  // Matches the old userscript exactly:
  //   Hours    = SHOW_HOURS Forecast, summed INBOUND + DA
  //   Cartons  = CAPABILITY_COMBINED_CARTONS Forecast, INBOUND only
  //   Rostered = SCHEDULED_HOURS Forecast, summed INBOUND + DA
  //   Attend % = round((1 - ABSENCE_HOURS / SCHEDULED_HOURS) * 100), IB+DA
  // Dates are mapped to the LVP week (weekStart Sunday .. +6) by weekday name.
  const autoFillFromAlps = async () => {
    try {
      setAlpsFillMsg('Loading ALPS…');
      const d = await fetch(`${api}/api/fclm/cache?site=${site}&date=ALPS_${site}&shift_type=data`).then(r => r.json());
      const rows = (d && Array.isArray(d.rows)) ? d.rows : [];
      if (!rows.length) { setAlpsFillMsg('No ALPS data in cache yet.'); return; }
      // pivot: concept|proc|shift|date -> value (FORECAST aspect)
      const pv = {};
      rows.forEach(r => {
        if ((r.aspect || '') !== 'FORECAST') return;
        pv[`${r.concept}|${r.mainProcess}|${r.shift}|${r.date}`] = r.value;
      });
      const num = (v) => (v == null || isNaN(v) ? null : Number(v));
      const sumIBDA = (concept, sh, date) => {
        const a = num(pv[`${concept}|INBOUND|${sh}|${date}`]);
        const b = num(pv[`${concept}|DA|${sh}|${date}`]);
        if (a == null && b == null) return null;
        return (a || 0) + (b || 0);
      };
      const ibOnly = (concept, sh, date) => num(pv[`${concept}|INBOUND|${sh}|${date}`]);

      // Week dates: weekStart (Sunday) .. +6, matched to the ALPS date strings.
      const ws = weekStart; // 'YYYY-MM-DD' (Sunday)
      const dateFor = (i) => { const dt = new Date(ws + 'T12:00:00'); dt.setDate(dt.getDate() + i); return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`; };

      const newShift = { ...shiftData };
      const newRostered = { ...rosteredHours };
      const newAtt = { ...attendanceRate };
      let filled = 0, missing = [];
      [['DAY_SHIFT', 'day'], ['NIGHT_SHIFT', 'night']].forEach(([alpsShift, sfx]) => {
        DAYS.forEach((dayName, i) => {
          const date = dateFor(i);
          const k = `${dayName}_${sfx}`;
          const hours = sumIBDA('SHOW_HOURS', alpsShift, date);
          const cartons = ibOnly('CAPABILITY_COMBINED_CARTONS', alpsShift, date);
          const sched = sumIBDA('SCHEDULED_HOURS', alpsShift, date);
          const absence = sumIBDA('ABSENCE_HOURS', alpsShift, date);
          if (hours == null && cartons == null && sched == null) { missing.push(k); return; }
          newShift[k] = { hours: hours != null ? Math.round(hours) : (newShift[k]?.hours || 0), cartons: cartons != null ? Math.round(cartons) : (newShift[k]?.cartons || 0) };
          if (sched != null) newRostered[k] = String(Math.round(sched));
          if (sched != null && sched > 0 && absence != null) newAtt[k] = Math.round((1 - absence / sched) * 100);
          filled++;
        });
      });
      if (!filled) { setAlpsFillMsg('ALPS has no data for this LVP week (' + ws + '). Check the date range.'); return; }
      setShiftData(newShift); setRosteredHours(newRostered); setAttendanceRate(newAtt);
      setAlpsFillMsg(`Filled ${filled}/14 shift-days from ALPS (week ${ws})${missing.length ? ' · missing: ' + missing.join(', ') : ''}. Review & Save.`);
    } catch (e) {
      setAlpsFillMsg('ALPS auto-fill failed: ' + e.message);
    }
  };

  // Load MEESA data for B3of4 function rates
  useEffect(() => {
    fetch(`${api}/api/meesa?site=${site}`)
      .then(r => r.json())
      .then(data => {
        if (!Array.isArray(data)) return;
        const filtered = data.filter(w => w.weekStart >= '2025-12-28');
        const complete = filtered.length > 1 ? filtered.slice(0, -1) : [];
        const last4 = complete.slice(-4);

        const rates = {};
        // Map function names to line item IDs for those that come from PPR lines
        const FN_TO_LINE = {
          'Receive ProblemSolve': 'ibProblemSolve',
          'Receive Lead/PA': 'ibLeadPa',
          'TransferOut PSolve': 'toProblemSolve',
          'Transfer Out Lead/PA': 'toLeadPa',
          '_line_lpReceive': 'lpReceive',
          '_line_palletReceive': 'palletReceive',
          '_line_eachReceiveSmall': 'eachReceiveSmall',
          '_line_prepRecorderSmall': 'prepRecorderSmall',
          'Trans Out Overflow': 'transferOutOverflow',
        };
        DEPTS.forEach(dept => {
          dept.functions.forEach(({ fn }) => {
            // Check if this is a line item
            const lineId = FN_TO_LINE[fn];
            if (lineId) {
              const fnRates = last4.map(w => w.lines?.[lineId]?.rate || 0).filter(r => r > 0);
              fnRates.sort((a, b) => b - a);
              const top3 = fnRates.slice(0, 3);
              rates[fn] = top3.length > 0 ? top3.reduce((s, v) => s + v, 0) / top3.length : 0;
              return;
            }
            const cartonKey = FN_CARTON_MAP[fn];
            const fnRates = last4.map(w => {
              const allFns = Object.values(w.functions || {}).flat();
              const f = allFns.find(x => x.name === fn);
              if (!f || !f.hours || f.hours <= 0) return 0;
              if (cartonKey && w.cartons) {
                const c = w.cartons[cartonKey] || 0;
                return c > 0 ? c / f.hours : 0;
              }
              return f.rate || 0;
            }).filter(r => r > 0);
            fnRates.sort((a, b) => b - a);
            const top3 = fnRates.slice(0, 3);
            rates[fn] = top3.length > 0 ? top3.reduce((s, v) => s + v, 0) / top3.length : 0;
          });
        });
        // IDRT rate (shared baseline for IDRT EOL + IDRT AROS). IDRT labor is
        // tracked in three places, so hours = EOL Sort (Offline_Mods) + AROS Sort
        // (Jackpot Kickout) functionRollup hours + the rsrSupport PPR line hours;
        // rate = (eol + aros cartons) / those hours. B3of4 across the last 4 weeks.
        // (Matches the MEESA RSR Support — Function Detail table.)
        const idrtWeekRates = last4.map(w => {
          // EOL Sort / AROS Sort are the transferOut functions (not the ibPR
          // Pallet Build 'Offline_Mods'), plus the rsrSupport PPR line.
          const eolSortHrs = (w.functions?.transferOut || []).find(f => f.name === 'Offline_Mods')?.hours || 0;
          const arosSortHrs = (w.functions?.transferOut || []).find(f => f.name === 'Jackpot Kickout')?.hours || 0;
          const rsrHrs = w.lines?.rsrSupport?.hours || 0;
          const h = eolSortHrs + arosSortHrs + rsrHrs;
          const c = (w.cartons?.eol || 0) + (w.cartons?.aros || 0);
          return h > 0 ? c / h : 0;
        }).filter(r => r > 0);
        idrtWeekRates.sort((a, b) => b - a);
        const idrtTop3 = idrtWeekRates.slice(0, 3);
        const idrtRate = idrtTop3.length ? idrtTop3.reduce((s, v) => s + v, 0) / idrtTop3.length : 0;
        rates['__IDRT_EOL__'] = idrtRate;
        rates['__IDRT_AROS__'] = idrtRate;
        setFuncRates(rates);
        // 4-week average per-shift static hours for flat-staffed functions (weekly avg ÷ 14 shifts)
        const flatH = {};
        FLAT_STAFF_FUNCTIONS.forEach(fn => {
          const hs = last4.map(w => { const f = Object.values(w.functions || {}).flat().find(x => x.name === fn); return f?.hours || 0; }).filter(h => h > 0);
          flatH[fn] = hs.length ? Math.round((hs.reduce((s, v) => s + v, 0) / hs.length) / 14 * 10) / 10 : 0;
        });
        setFlatFnHours(flatH);
        setMeesaLoaded(true);

        // Default week start (Sunday of the current Pacific week).
        // Build the string from LOCAL components — toISOString() converts to UTC,
        // which after ~5pm PT rolls the date to tomorrow and lands on Monday,
        // producing an LVP_<Monday> key with no saved plan (blank LVP).
        const nowPac = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
        const day = nowPac.getDay();
        const sunday = new Date(nowPac); sunday.setDate(nowPac.getDate() - day);
        const ws = `${sunday.getFullYear()}-${String(sunday.getMonth() + 1).padStart(2, '0')}-${String(sunday.getDate()).padStart(2, '0')}`;
        setWeekStart(ws);
      }).catch(() => {});
  }, [api, site]);

  // Load saved plan
  useEffect(() => {
    if (!weekStart) return;
    // Base admin = static ADMIN_DEFAULTS, overlaid with the live 4-week per-function
    // average (ADMIN_AVG_<site>, refreshed weekly by admin-avg-sync.sh). The saved
    // plan then wins per the fetch below, so manually-set weeks are never clobbered
    // — only unsaved weeks auto-fill from the rolling average.
    const applyBaseThenPlan = (base) => {
      setAdminDetail(JSON.parse(JSON.stringify(base)));
      fetch(`${api}/api/fclm/cache?site=${site}&date=LVP_${weekStart}&shift_type=plan`)
        .then(r => r.json())
        .then(data => {
          if (data?.shiftData) setShiftData(data.shiftData);
          if (data?.fppRatios) setFppRatios(data.fppRatios);
          if (data?.eolPct !== undefined) setEolPct(data.eolPct);
          if (data?.cpp !== undefined) { setCpp(data.cpp); setCppInput(String(data.cpp)); }
          if (data?.trailerText) setTrailerText(data.trailerText);
          if (data?.overrides) setOverrides(data.overrides);        // adminHours is auto-computed from adminDetail, don't load stale values
          if (data?.flatStaffing !== undefined) setFlatStaffing(data.flatStaffing);
          if (data?.adminDetail) setAdminDetail(data.adminDetail);  // saved plan wins (manual entries)
          if (data?.rosteredHours) setRosteredHours(Object.fromEntries(Object.entries(data.rosteredHours).map(([k, v]) => [k, v === '' || v == null ? v : String(Math.round(parseFloat(v)) || 0)])));
          if (data?.attendanceRate) setAttendanceRate(data.attendanceRate);
        }).catch(() => {});
    };
    fetch(`${api}/api/fclm/cache?site=${site}&date=ADMIN_AVG_${site}&shift_type=data`)
      .then(r => r.json())
      .then(avg => {
        const base = JSON.parse(JSON.stringify(ADMIN_DEFAULTS));
        const ad = avg?.adminDetail;
        if (ad) for (const fn of Object.keys(ad)) base[fn] = { ...(base[fn] || {}), ...ad[fn] };
        applyBaseThenPlan(base);
      })
      .catch(() => applyBaseThenPlan(JSON.parse(JSON.stringify(ADMIN_DEFAULTS))));
  }, [api, site, weekStart]);

  // Auto-populate admin hours from 4-week average: now done server-side by
  // admin-avg-sync.sh (per function, weekly) and layered into adminDetail above.

  // Auto-sum admin detail into admin hours row (excludes TOM - counted separately)
  useEffect(() => {
    const dKeys = DAYS.map(d => d + '_day');
    const nKeys = DAYS.map(d => d + '_night');
    const aKeys = [...dKeys, ...nKeys];
    const sums = {};
    aKeys.forEach(k => {
      let total = 0;
      ADMIN_CATEGORIES.forEach(cat => {
        if (cat.label === 'TOM HOURS') return; // TOM excluded from admin hours
        cat.functions.forEach(fn => {
          total += parseFloat(adminDetail[fn]?.[k]) || 0;
        });
      });
      sums[k] = total > 0 ? total.toFixed(1) : '0';
    });
    setAdminHours(sums);
  }, [adminDetail]);

  // Parse trailer list
  const parseTrailers = (text) => {
    const lines = text.trim().split('\n').filter(l => l.trim());
    let pid = 0, pr = 0, manr = 0, skid = 0;
    lines.forEach(line => {
      const cols = line.split('\t').map(c => c.trim());
      const path = (cols[1] || '').toUpperCase();
      const cartons = parseInt((cols[2] || '').replace(/,/g, '')) || 0;
      if (path.includes('PID')) pid += cartons;
      else if (path.includes('MANR')) manr += cartons;
      else if (path.includes('SKID')) skid += cartons;
      else if (path.includes('PR')) pr += cartons;
    });
    const total = pid + pr + manr + skid;
    if (total > 0) setFppRatios({ pid: pid / total, aros: manr / total, pr: pr / total, skid: skid / total });
    setTrailerText(text);
  };

  // Get volumes for a shift key (pure helper lvpVols, shared with MSM)
  const getVols = (shiftKey) => lvpVols(shiftData[shiftKey], fppRatios, eolPct);

  // Get rate for a function (check override first, then B3of4)
  const getFnRate = (fn, shiftKey, dept) => {
    const ov = overrides[fn]?.rate?.[shiftKey];
    if (ov !== undefined && ov !== '') return parseFloat(ov) || 0;
    if (flatStaffing && FLAT_STAFF_FUNCTIONS.has(fn)) {
      const fh = flatFnHours[fn] || 0;
      if (fh > 0) { const vk = FN_CARTON_MAP[fn]; const vol = vk ? (getVols(shiftKey)[vk] || 0) : 0; if (vol > 0) return vol / fh; }
    }
    return b3of4OrExpected(fn, dept);
  };

  // Get dept rate = dept volume / sum of function hours
  const getDeptRate = (dept, shiftKey) => {
    const ov = overrides[dept.id]?.rate?.[shiftKey];
    if (ov !== undefined && ov !== '') return parseFloat(ov) || 0;
    const vols = getVols(shiftKey);
    const deptVol = vols[dept.volKey] || 0;
    const deptHours = getDeptHours(dept, shiftKey);
    return deptHours > 0 ? deptVol / deptHours : 0;
  };

  // ---- B3of4 rate helper ------------------------------------------------------
  // Historical best-3-of-4 rate for a function. (Q3G scaling was removed: the LVP
  // always plans off B3of4; Q3G is reference-only.)
  const b3of4OrExpected = (fn, dept) => {
    return funcRates[fn] || 0;
  };
  // Hours that are pinned by the user: an hours override, a rate override, or
  // Flat Staffing. Returns the pinned hours, or null if the function is free.
  const fixedFnHours = (fn, dept, shiftKey) => {
    const ovH = overrides[fn]?.hours?.[shiftKey];
    if (ovH !== undefined && ovH !== '') return parseFloat(ovH) || 0;
    if (flatStaffing && FLAT_STAFF_FUNCTIONS.has(fn)) return flatFnHours[fn] || 0;
    const ovR = overrides[fn]?.rate?.[shiftKey];
    if (ovR !== undefined && ovR !== '') {
      const r = parseFloat(ovR) || 0; if (!(r > 0)) return 0;
      const vols = getVols(shiftKey);
      if (fn === '_line_palletReceive') return ((vols.pr || 0) / cpp) / r;
      const vk = resolveFnVolKey(fn, dept);
      return (vols[vk] || vols[dept.volKey] || 0) / r;
    }
    return null;
  };
  // B3of4 hours for a function = volume / B3of4 rate.
  const baseFnHours = (fn, dept, shiftKey) => {
    const vols = getVols(shiftKey);
    const r = b3of4OrExpected(fn, dept);
    if (!(r > 0)) return 0;
    if (fn === '_line_palletReceive') return ((vols.pr || 0) / cpp) / r;
    const vk = resolveFnVolKey(fn, dept);
    return (vols[vk] || vols[dept.volKey] || 0) / r;
  };
  // Q3G target diluted CPLH (PPID 609 THROUGHPUT) for the plan week, if Q3G has
  // rates for the week; 0 otherwise. Reference-only — shown in the Q3G Target
  // CPLH row, never used to scale planned hours.
  const q3gTargetDiluted = q3gWeekKey(weekStart) ? q3gRate('609', weekStart) : 0;
  const casualFor = (fn, dept) => (dept?.functions || []).find(f => f.fn === fn)?.casual;

  // Get function hours
  const getFnHours = (fn, dept, shiftKey) => {
    // Pinned (hours/rate override or Flat Staffing): return as-is.
    const fixed = fixedFnHours(fn, dept, shiftKey);
    if (fixed !== null) return fixed;
    const vols = getVols(shiftKey);
    // Pallet Receive uses pallets (PR cartons / CPP), not cartons
    if (fn === '_line_palletReceive') {
      const pallets = (vols.pr || 0) / cpp;
      const rate = getFnRate(fn, shiftKey, dept);
      return rate > 0 ? (pallets / rate) : 0;
    }
    const fnVolKey = resolveFnVolKey(fn, dept);
    const vol = vols[fnVolKey] || vols[dept.volKey] || 0;
    const rate = getFnRate(fn, shiftKey, dept);
    return rate > 0 ? (vol / rate) : 0;
  };

  // Get dept hours = sum of function hours (or override)
  const getDeptHours = (dept, shiftKey) => {
    const ov = overrides[dept.id]?.hours?.[shiftKey];
    if (ov !== undefined && ov !== '') return parseFloat(ov) || 0;
    return dept.functions.reduce((sum, { fn }) => sum + getFnHours(fn, dept, shiftKey), 0);
  };

  // Get total required hours for a shift
  const getRequiredHours = (shiftKey) => DEPTS.reduce((sum, dept) => sum + getDeptHours(dept, shiftKey), 0);

  // Get IB hours (first 4 depts + ibSupport)
  const arosDept = DEPTS.find(x => x.id === 'aros');
  const sorterDept = DEPTS.find(x => x.id === 'sorterEOL');
  // IDRT EOL (__IDRT_EOL__, in sorterEOL) and IDRT AROS (__IDRT_AROS__, in aros)
  // are IDRT scanning labor — they roll up under INBOUND, not Outbound. They
  // physically sit in the sorterEOL/aros depts (for per-dept display), so IB
  // ADDS them and DA SUBTRACTS them from those dept sums to avoid double-count.
  const idrtEolHrs = (k) => getFnHours('__IDRT_EOL__', sorterDept, k);
  const idrtArosHrs = (k) => getFnHours('__IDRT_AROS__', arosDept, k);
  const getIBHours = (shiftKey) => ['pid', 'ibPR', 'ibPIT', 'ibSupport'].reduce((s, id) => { const d = DEPTS.find(x => x.id === id); return s + (d ? getDeptHours(d, shiftKey) : 0); }, 0)
    + ['ReceiveLine Unloader', 'Receive Dock Crew', 'PID Sort Line'].reduce((s, fn) => s + getFnHours(fn, arosDept, shiftKey), 0)
    + idrtEolHrs(shiftKey) + idrtArosHrs(shiftKey);   // IDRT EOL + IDRT AROS roll up under IB

  // Get DA hours (EOL + fluid + obPR + obSupport + AROS outbound functions),
  // EXCLUDING the two IDRT lines (now counted in IB above).
  const getDAHours = (shiftKey) => ['sorterEOL', 'fluid', 'obPR', 'obSupport'].reduce((s, id) => { const d = DEPTS.find(x => x.id === id); return s + (d ? getDeptHours(d, shiftKey) : 0); }, 0)
    + ['MHE Support', 'Robotic Problem Solv', 'Jackpot Kickout', 'Robotic Water Spider'].reduce((s, fn) => s + getFnHours(fn, arosDept, shiftKey), 0)
    // IDRT EOL sits in the sorterEOL dept sum above, so subtract it (moved to IB).
    // IDRT AROS is NOT in the DA sum (only the 4 named AROS functions are), so
    // subtracting it too dropped the whole IDRT AROS line from Planned hours.
    - idrtEolHrs(shiftKey);

  // Set override helper
  const setOverride = (key, type, shiftKey, value) => {
    setOverrides(prev => ({
      ...prev,
      [key]: { ...prev[key], [type]: { ...(prev[key]?.[type] || {}), [shiftKey]: value } }
    }));
  };

  // Recompute a whole path (dept) from volume: clear the dept's and its
  // functions' hours+rate overrides so getFnHours falls back to live
  // (volume / loaded B3of4 rate) for every function under that path.
  const recomputeDeptFromVolume = (dept) => {
    setOverrides(prev => {
      const next = { ...prev };
      delete next[dept.id];
      dept.functions.forEach(({ fn }) => { delete next[fn]; });
      return next;
    });
  };

  // Save plan
  const savePlan = async () => {
    // Compute all function hours for each shift to save with the plan
    const computedHours = {};
    const allShiftKeys = DAYS.flatMap(d => [d + '_day', d + '_night']);
    DEPTS.forEach(dept => {
      dept.functions.forEach(({ casual, fn }) => {
        computedHours[casual] = {};
        allShiftKeys.forEach(k => {
          computedHours[casual][k] = Math.round(getFnHours(fn, dept, k) * 10) / 10;
        });
      });
      // Also save dept totals
      computedHours[dept.name] = {};
      allShiftKeys.forEach(k => {
        computedHours[dept.name][k] = Math.round(getDeptHours(dept, k) * 10) / 10;
      });
    });

    // Expected (rostered x attendance), IB/DA required, and Planned (=IB+DA, post VET/VTO)
    const ibHours = {}, daHours = {}, expectedHours = {}, plannedHours = {};
    allShiftKeys.forEach(k => {
      ibHours[k] = Math.round(getIBHours(k) * 10) / 10;
      daHours[k] = Math.round(getDAHours(k) * 10) / 10;
      expectedHours[k] = Math.round((parseFloat(rosteredHours[k]) || 0) * (parseFloat(attendanceRate[k]) || 0) / 100);
      plannedHours[k] = Math.round(getIBHours(k) + getDAHours(k));
    });

    await fetch(`${api}/api/fclm/cache`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ site, date: `LVP_${weekStart}`, shift_type: 'plan', data: { shiftData, fppRatios, eolPct, cpp, trailerText, overrides, adminHours, adminDetail, rosteredHours, attendanceRate, computedHours, ibHours, daHours, expectedHours, plannedHours, flatStaffing } }),
    });
    // Push shift plans to hourly tab via shift-plans API
    for (let i = 0; i < DAYS.length; i++) {
      for (const shift of ['day', 'night']) {
        const key = DAYS[i] + '_' + shift;
        const cartons = shiftData[key]?.cartons || 0;
        if (cartons <= 0) continue;
        const dateObj = new Date(weekStart + 'T12:00:00'); dateObj.setDate(dateObj.getDate() + i);
        const dateStr = dateObj.toISOString().split('T')[0];
        const vols = getVols(key);
        await fetch(`${api}/api/shift-plans`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            site, date: dateStr, shift_type: shift,
            volumes: [
              { key: 'pid', volume: vols.pid, process_path_id: 1 },
              { key: 'aros', volume: vols.aros, process_path_id: 2 },
              { key: 'pallet', volume: vols.pr, process_path_id: 3 },
            ],
            group_hours: [{ group_id: 1, hours: shiftData[key]?.hours || 0 }],
          }),
        });
      }
    }
    setSaved(true); setTimeout(() => setSaved(false), 3000);
  };

  const updateShift = (key, field, val) => setShiftData(prev => ({ ...prev, [key]: { ...prev[key], [field]: (field === 'pidCartons' || field === 'arosCartons') ? val : (parseFloat(val) || 0) } }));

  // Most Efficient Execution: rebalance the per-shift path MIX (PID<->AROS<->PR) to flatten
  // Extra Hours as a % of Expected across shifts, holding each shift's TOTAL cartons and each
  // path's WEEKLY total constant. AROS/PR are labor-heavy, PID/Sorter is light; moving heavy
  // volume onto slack shifts (and light volume off them) consumes their extra hours, with a
  // matching opposite swap on a tight shift so weekly path totals never change.
  const mostEfficientExecution = () => {
    const KEYS = []; DAYS.forEach(d => { KEYS.push(d + '_day'); KEYS.push(d + '_night'); });
    const e = (eolPct || 0) / 100;
    const S = {};
    KEYS.forEach(k => {
      const total = shiftData[k]?.cartons || 0;
      const rostered = parseFloat(rosteredHours[k]) || 0;
      const att = parseFloat(attendanceRate[k]) || 0;
      const expected = rostered * att / 100;
      if (total > 0 && expected > 0) { const v = getVols(k); S[k] = { total, expected, pid: v.pid, aros: v.aros }; }
    });
    const keys = Object.keys(S);
    if (keys.length === 0) { setMeeInfo('No shifts with both cartons and rostered hours to balance.'); return; }

    // Planned (IB+DA required) hours for a trial mix — mirrors getVols + getFnHours (rates per shift)
    const planned = (k, pid, aros) => {
      const total = S[k].total;
      const pr = Math.max(0, total - pid - aros);
      const eol = Math.round(pid * e);
      const vols = { pid, aros, pr, skid: 0, eol, fluidDirect: pid - eol, fluidOffline: eol + aros, fluidTotal: pid + aros, ibCartons: total, daCartons: total, ob: total, obPR: pr };
      let h = 0;
      for (const dept of DEPTS) for (const { fn } of dept.functions) {
        const rate = getFnRate(fn, k, dept); if (!(rate > 0)) continue;
        if (fn === '_line_palletReceive') { h += (vols.pr / (cpp || 1)) / rate; continue; }
        const vk = resolveFnVolKey(fn, dept);
        const vol = vols[vk] != null ? vols[vk] : (vols[dept.volKey] || 0);
        h += vol / rate;
      }
      return h;
    };

    const sumExpected = keys.reduce((s, k) => s + S[k].expected, 0);
    const sumPlanned0 = keys.reduce((s, k) => s + planned(k, S[k].pid, S[k].aros), 0);
    const ratio = sumExpected > 0 ? sumPlanned0 / sumExpected : 1; // target Planned/Expected => flat Extra/Expected
    keys.forEach(k => { S[k].target = S[k].expected * ratio; });

    const mix = {}; keys.forEach(k => { mix[k] = { pid: S[k].pid, aros: S[k].aros }; });
    const CAP = 9100; // max AROS per shift
    const gap = (k) => S[k].target - planned(k, mix[k].pid, mix[k].aros); // >0 => needs MORE hours (slack)

    for (let iter = 0; iter < 100000; iter++) {
      const g = {}; keys.forEach(k => { g[k] = gap(k); });
      const slack = keys.filter(k => g[k] > 1).sort((a, b) => g[b] - g[a]); // need MORE hours
      const tight = keys.filter(k => g[k] < -1).sort((a, b) => g[a] - g[b]); // need FEWER hours
      if (!slack.length || !tight.length) break;
      let moved = false;
      for (const A of slack) {
        for (const B of tight) {
          if (A === B) continue;
          const mA = mix[A], mB = mix[B], ga = g[A], gb = g[B];
          // AROS swap: A +aros/-pid (heavier), B -aros/+pid (lighter). Preserves weekly PID & AROS.
          const mAa = (mA.pid >= 1 && mA.aros < CAP) ? planned(A, mA.pid - 1, mA.aros + 1) - planned(A, mA.pid, mA.aros) : 0;
          const mBa = (mB.aros >= 1) ? planned(B, mB.pid, mB.aros) - planned(B, mB.pid + 1, mB.aros - 1) : 0;
          if (mAa > 0 && mBa > 0) {
            const d = Math.min(CAP - mA.aros, mA.pid, mB.aros, Math.floor(Math.min(ga / mAa, (-gb) / mBa)));
            if (d >= 1) { mA.aros += d; mA.pid -= d; mB.aros -= d; mB.pid += d; moved = true; break; }
          }
          // PR swap: A -pid/+pr, B +pid/-pr. Preserves weekly PID (and AROS untouched).
          const mAp = (mA.pid >= 1) ? planned(A, mA.pid - 1, mA.aros) - planned(A, mA.pid, mA.aros) : 0;
          const mBp = planned(B, mB.pid, mB.aros) - planned(B, mB.pid + 1, mB.aros);
          if (mAp > 0 && mBp > 0) {
            const d = Math.min(mA.pid, S[B].total - mB.pid - mB.aros, Math.floor(Math.min(ga / mAp, (-gb) / mBp)));
            if (d >= 1) { mA.pid -= d; mB.pid += d; moved = true; break; }
          }
        }
        if (moved) break;
      }
      if (!moved) break; // no feasible improving swap between any slack/tight pair
    }

    setShiftData(prev => {
      const n = { ...prev };
      keys.forEach(k => { n[k] = { ...n[k], pidCartons: String(mix[k].pid), arosCartons: String(mix[k].aros) }; });
      return n;
    });
    // Clear per-function/dept HOURS overrides on these shifts so the new mix drives hours (rates kept)
    setOverrides(prev => {
      const n = {};
      for (const [id, val] of Object.entries(prev)) {
        const nv = { ...val };
        if (nv.hours) { const h = { ...nv.hours }; keys.forEach(k => delete h[k]); nv.hours = h; }
        n[id] = nv;
      }
      return n;
    });

    const pcts = keys.map(k => (S[k].expected - planned(k, mix[k].pid, mix[k].aros)) / S[k].expected * 100);
    setMeeInfo(`Rebalanced ${keys.length} shifts · target Extra ${((1 - ratio) * 100).toFixed(1)}% of Expected · now ${Math.min(...pcts).toFixed(1)}–${Math.max(...pcts).toFixed(1)}% · totals unchanged. Review the Extra Hours row, then Save Plan.`);
  };

  const cellStyle = { padding: '1px 2px', textAlign: 'center', fontSize: '0.6rem', fontWeight: 500, border: '1px solid #ccc', whiteSpace: 'nowrap', maxWidth: 52 };
  const headerStyle = { ...cellStyle, fontWeight: 700, background: '#1a3a5c', color: '#fff', padding: '2px 3px' };
  const inputStyle = { width: 48, border: 'none', textAlign: 'center', fontSize: '0.6rem', padding: '1px', background: 'transparent' };

  if (!meesaLoaded) return <div><h2 className="section-title">LVP — Labor Volume Plan — {site}</h2><div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 40 }}><img src={loadingImage()} alt="Loading" style={{ width: 80, height: 80, animation: 'spin 1.5s linear infinite' }} /><p style={{ marginTop: 12, fontSize: '0.85rem', color: '#666' }}>Loading Bottoms Up Forecast rates...</p><style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style></div></div>;

  // All shift keys in order
  const dayKeys = DAYS.map(d => d + '_day');
  const nightKeys = DAYS.map(d => d + '_night');
  const allKeys = [...dayKeys, ...nightKeys];

  // Site total helpers
  const siteTotal = (fn) => allKeys.reduce((s, k) => s + fn(k), 0);

  return (
    <div>
      <h2 className="section-title">LVP — Labor Volume Plan — {site}</h2>

      <div className="card">
        <div className="form-row" style={{ flexWrap: 'wrap' }}>
          <div className="form-group"><label>Week Start</label><input type="date" value={weekStart} onChange={e => setWeekStart(e.target.value)} /></div>
          <div className="form-group"><button className="btn btn-primary" onClick={savePlan} style={{ fontSize: '0.75rem', padding: '5px 14px' }}>{saved ? '✅ Saved!' : '💾 Save Plan'}</button></div>
          <div className="form-group"><button className="btn btn-secondary" onClick={() => setOverrides({})} style={{ fontSize: '0.7rem', padding: '4px 10px' }}>🔄 Reset to B3of4</button></div>
          <div className="form-group"><button className="btn btn-primary" onClick={mostEfficientExecution} style={{ fontSize: '0.7rem', padding: '4px 10px', background: '#6a1b9a' }} title="Rebalance the PID/AROS/PR mix across shifts to flatten Extra Hours % — shift totals and weekly path totals stay the same">⚡ Most Efficient Execution</button></div>
          <div className="form-group"><button className={`btn ${flatStaffing ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setFlatStaffing(!flatStaffing)} style={{ fontSize: '0.7rem', padding: '4px 10px' }} title="Hold IB Clerk, IB TDR, Jam Clear (MHE Support), EOL Divert, EOL Avery, and Ship Clerk at their 4-week-average static hours per shift instead of scaling with planned cartons. Manual overrides still win.">{flatStaffing ? '🔒 Flat Staffing: ON' : '🔓 Flat Staffing: OFF'}</button></div>
          {meeInfo && <div className="form-group" style={{ flexBasis: '100%' }}><span style={{ fontSize: '0.68rem', color: '#6a1b9a', fontWeight: 600 }}>{meeInfo}</span></div>}
          <div className="form-group">
            <button className="btn btn-secondary" onClick={() => {
              const header = 'Shift,Rostered Hours,Attendance %,Hours,Cartons';
              const dayRows = DAYS.map((d,i) => `${d} Day,0,${[75,86,83,83,86,85,83][i]},0,0`);
              const nightRows = DAYS.map((d,i) => `${d} Night,0,${[74,85,82,82,85,84,82][i]},0,0`);
              const csv = [header, ...dayRows, ...nightRows].join('\n');
              const a = document.createElement('a'); a.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv' })); a.download = 'lvp_template.csv'; a.click();
            }} style={{ fontSize: '0.7rem', padding: '4px 10px' }}>📥 Template</button>
          </div>
          <div className="form-group">
            <label className="btn btn-secondary" style={{ fontSize: '0.7rem', padding: '4px 10px', cursor: 'pointer' }}>
              📤 Upload CSV
              <input type="file" accept=".csv" style={{ display: 'none' }} onChange={e => {
                const file = e.target.files[0]; if (!file) return;
                file.text().then(text => {
                  const lines = text.trim().split('\n').slice(1);
                  const updated = { ...shiftData };
                  const updatedRostered = { ...rosteredHours };
                  const updatedAttendance = { ...attendanceRate };
                  lines.forEach(line => {
                    const cols = line.split(',').map(c => c.trim());
                    const label = cols[0].toLowerCase();
                    const rostered = Math.round(parseFloat(cols[1]) || 0);
                    const attendance = parseFloat(cols[2]) || 0;
                    const hours = parseFloat(cols[3]) || 0;
                    const cartons = Math.round(parseFloat(cols[4]) || 0);
                    // Match to shift key
                    DAYS.forEach(day => {
                      if (label.includes(day.toLowerCase()) && label.includes('day') && !label.includes('night')) {
                        const k = day + '_day';
                        updated[k] = { hours, cartons };
                        if (rostered) updatedRostered[k] = String(rostered);
                        if (attendance) updatedAttendance[k] = attendance;
                      } else if (label.includes(day.toLowerCase()) && label.includes('night')) {
                        const k = day + '_night';
                        updated[k] = { hours, cartons };
                        if (rostered) updatedRostered[k] = String(rostered);
                        if (attendance) updatedAttendance[k] = attendance;
                      }
                    });
                  });
                  setShiftData(updated);
                  setRosteredHours(updatedRostered);
                  setAttendanceRate(updatedAttendance);
                });
                e.target.value = '';
              }} />
            </label>
          </div>
          <div className="form-group">
            <button className="btn btn-secondary" onClick={autoFillFromAlps} title="Fill Rostered/Attendance/Hours/Cartons from the ALPS plan for this week (replaces the ALPS CSV upload)" style={{ fontSize: '0.7rem', padding: '4px 10px' }}>⚡ Auto-fill from ALPS</button>
            {alpsFillMsg && <span style={{ fontSize: '0.65rem', color: alpsFillMsg.includes('failed') || alpsFillMsg.includes('No ') || alpsFillMsg.includes('no data') ? '#c0392b' : '#27ae60', marginLeft: 8 }}>{alpsFillMsg}</span>}
          </div>
          <div className="form-group">
            <button className="btn btn-secondary" onClick={() => {
              const header = ['Function', ...allKeys.map(k => k.replace('_', ' '))].join(',');
              const rows = [];
              // Production hours by dept and function
              DEPTS.forEach(dept => {
                rows.push([dept.name + ' Hours', ...allKeys.map(k => Math.round(getDeptHours(dept, k)) || '')].join(','));
                dept.functions.forEach(({ casual, fn }) => {
                  rows.push(['  ' + casual, ...allKeys.map(k => Math.round(getFnHours(fn, dept, k) * 10) / 10 || '')].join(','));
                });
              });
              rows.push(['--- PRODUCTION TOTAL ---', ...allKeys.map(k => Math.round(getRequiredHours(k)) || '')].join(','));
              rows.push([]);
              // Admin hours by category and function
              rows.push(['--- ADMIN HOURS ---'].join(','));
              ADMIN_CATEGORIES.forEach(cat => {
                const catTotal = allKeys.map(k => cat.functions.reduce((s, fn) => s + (parseFloat(adminDetail[fn]?.[k]) || 0), 0));
                rows.push([cat.label + ' Total', ...catTotal.map(v => v > 0 ? v.toFixed(1) : '')].join(','));
                cat.functions.forEach(fn => {
                  const vals = adminDetail[fn] || {};
                  rows.push(['  ' + fn, ...allKeys.map(k => vals[k] || '')].join(','));
                });
              });
              rows.push(['--- ADMIN TOTAL ---', ...allKeys.map(k => adminHours[k] || '')].join(','));
              const csv = [header, ...rows].join('\n');
              const a = document.createElement('a'); a.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv' })); a.download = `LVP_${weekStart}_hours.csv`; a.click();
            }} style={{ fontSize: '0.7rem', padding: '4px 10px' }}>📊 Export Hours</button>
          </div>
        </div>
      </div>

      <div className="card">
        <h3 className="section-title">Trailer List (Paste: ISA, Path, Cartons, ASINs, Status, Notes)</h3>
        <textarea rows={3} style={{ width: '100%', fontSize: '0.7rem', fontFamily: 'monospace' }} value={trailerText} onChange={e => parseTrailers(e.target.value)} placeholder="Paste trailer list here..." />
        <p style={{ fontSize: '0.7rem', margin: '4px 0 0' }}>
          <strong>FPP (from trailers):</strong> PID {(fppRatios.pid*100).toFixed(1)}% | AROS {(fppRatios.aros*100).toFixed(1)}% | PR {(fppRatios.pr*100).toFixed(1)}% | SKID {(fppRatios.skid*100).toFixed(1)}%
        </p>
        <div style={{ display: 'flex', gap: 8, marginTop: 6, alignItems: 'center', fontSize: '0.7rem' }}>
          <strong>Manual FPP Override:</strong>
          <label>PID %<input type="text" value={Math.round(fppRatios.pid*100)} onChange={e => { const v = parseFloat(e.target.value) || 0; setFppRatios(prev => ({...prev, pid: v/100})); }} style={{ width: 40, textAlign: 'center', marginLeft: 2, fontSize: '0.7rem', border: '1px solid #ccc', borderRadius: 2 }} /></label>
          <label>AROS %<input type="text" value={Math.round(fppRatios.aros*100)} onChange={e => { const v = parseFloat(e.target.value) || 0; setFppRatios(prev => ({...prev, aros: v/100})); }} style={{ width: 40, textAlign: 'center', marginLeft: 2, fontSize: '0.7rem', border: '1px solid #ccc', borderRadius: 2 }} /></label>
          <label>PR %<input type="text" value={Math.round(fppRatios.pr*100)} onChange={e => { const v = parseFloat(e.target.value) || 0; setFppRatios(prev => ({...prev, pr: v/100})); }} style={{ width: 40, textAlign: 'center', marginLeft: 2, fontSize: '0.7rem', border: '1px solid #ccc', borderRadius: 2 }} /></label>
          <label>SKID %<input type="text" value={Math.round(fppRatios.skid*100)} onChange={e => { const v = parseFloat(e.target.value) || 0; setFppRatios(prev => ({...prev, skid: v/100})); }} style={{ width: 40, textAlign: 'center', marginLeft: 2, fontSize: '0.7rem', border: '1px solid #ccc', borderRadius: 2 }} /></label>
        </div>
      </div>


      {/* Combined Days + Nights Table */}
      <div className="card" style={{ overflow: 'auto', maxHeight: '75vh' }}>
        <table style={{ borderCollapse: 'collapse', width: 'max-content' }}>
          <thead>
            <tr>
              <th style={{ ...headerStyle, textAlign: 'left', minWidth: 130, height: 20, boxSizing: 'border-box', position: 'sticky', left: 0, top: 0, zIndex: 4, background: '#1a3a5c' }}></th>
              <th colSpan={7} style={{ ...headerStyle, height: 20, boxSizing: 'border-box', position: 'sticky', top: 0, zIndex: 3, background: '#1a3a5c' }}>Days</th>
              <th colSpan={7} style={{ ...headerStyle, height: 20, boxSizing: 'border-box', position: 'sticky', top: 0, zIndex: 3, background: '#0d47a1' }}>Nights</th>
              <th style={{ ...headerStyle, height: 20, boxSizing: 'border-box', position: 'sticky', top: 0, zIndex: 3, background: '#333' }}>Site Total</th>
              <th style={{ ...headerStyle, height: 20, boxSizing: 'border-box', position: 'sticky', top: 0, zIndex: 3, background: '#666', fontSize: '0.55rem' }}>Copy</th>
            </tr>
            <tr>
              <th style={{ ...headerStyle, textAlign: 'left', position: 'sticky', left: 0, top: 20, zIndex: 4, background: '#1a3a5c' }}></th>
              {DAYS.map(d => <th key={d+'d'} style={{ ...headerStyle, position: 'sticky', top: 20, zIndex: 3 }}>{d.slice(0,3)}</th>)}
              {DAYS.map(d => <th key={d+'n'} style={{ ...headerStyle, position: 'sticky', top: 20, zIndex: 3, background: '#0d47a1' }}>{d.slice(0,3)}</th>)}
              <th style={{ ...headerStyle, position: 'sticky', top: 20, zIndex: 3, background: '#333' }}>Total</th>
              <th style={{ ...headerStyle, position: 'sticky', top: 20, zIndex: 3, background: '#666', fontSize: '0.5rem' }}>→All</th>
            </tr>
          </thead>
          <tbody>
            {/* Total Cartons */}
            {(() => {
              const rowKey = '_cartons';
              return <tr><td style={{ ...cellStyle, textAlign: 'left', fontWeight: 700, position: 'sticky', left: 0, background: '#fff', zIndex: 1 }}>Total Cartons</td>
                {allKeys.map(k => <td key={k} style={{ ...cellStyle, padding: '1px' }}><input type="text" value={shiftData[k]?.cartons || ''} onChange={e => updateShift(k, 'cartons', e.target.value)} style={inputStyle} /></td>)}
                <td style={{ ...cellStyle, fontWeight: 700 }}>{siteTotal(k => shiftData[k]?.cartons || 0).toLocaleString()}</td>
                <td style={cellStyle}><button onClick={() => { const v = shiftData[allKeys[0]]?.cartons || 0; const up = {...shiftData}; allKeys.forEach(k => { up[k] = {...up[k], cartons: v}; }); setShiftData(up); }} style={{ fontSize: '0.5rem', cursor: 'pointer', border: '1px solid #ccc', borderRadius: 2, padding: '1px 4px' }}>⟹</button></td>
              </tr>;
            })()}
            {/* PID Cartons */}
            <tr><td style={{ ...cellStyle, textAlign: 'left', position: 'sticky', left: 0, background: '#fff', zIndex: 1 }}>PID/Sorter Cartons</td>
              {allKeys.map(k => <td key={k} style={{ ...cellStyle, padding: '1px' }}><input type="text" value={shiftData[k]?.pidCartons !== undefined ? shiftData[k].pidCartons : Math.round((shiftData[k]?.cartons||0)*fppRatios.pid)} onChange={e => updateShift(k, 'pidCartons', e.target.value)} style={inputStyle} /></td>)}
              <td style={{ ...cellStyle, fontWeight: 600 }}>{Math.round(siteTotal(k=>getVols(k).pid)).toLocaleString()}</td><td style={cellStyle}></td>
            </tr>
            {/* AROS Cartons */}
            <tr><td style={{ ...cellStyle, textAlign: 'left', position: 'sticky', left: 0, background: '#fff', zIndex: 1 }}>AROS Cartons</td>
              {allKeys.map(k => <td key={k} style={{ ...cellStyle, padding: '1px' }}><input type="text" value={shiftData[k]?.arosCartons !== undefined ? shiftData[k].arosCartons : Math.round((shiftData[k]?.cartons||0)*fppRatios.aros)} onChange={e => updateShift(k, 'arosCartons', e.target.value)} style={inputStyle} /></td>)}
              <td style={{ ...cellStyle, fontWeight: 600 }}>{Math.round(siteTotal(k=>getVols(k).aros)).toLocaleString()}</td><td style={cellStyle}></td>
            </tr>
            {/* Pallet Cartons */}
            <tr><td style={{ ...cellStyle, textAlign: 'left', position: 'sticky', left: 0, background: '#fff', zIndex: 1 }}>Cartons from Pallets</td>
              {allKeys.map(k => <td key={k} style={cellStyle}>{getVols(k).pr.toLocaleString()}</td>)}
              <td style={{ ...cellStyle, fontWeight: 600 }}>{Math.round(siteTotal(k=>getVols(k).pr)).toLocaleString()}</td><td style={cellStyle}></td>
            </tr>
            {/* CPP */}
            <tr><td style={{ ...cellStyle, textAlign: 'left', position: 'sticky', left: 0, background: '#fff', zIndex: 1 }}>Cartons Per Pallet</td>
              {allKeys.map(k => <td key={k} style={cellStyle}>{cpp.toFixed(2)}</td>)}
              <td style={{ ...cellStyle, padding: '1px' }}><input type="text" inputMode="decimal" value={cppInput} onChange={e => { const s = e.target.value; setCppInput(s); const n = parseFloat(s); if (!isNaN(n)) setCpp(n); else if (s === '') setCpp(0); }} style={inputStyle} /></td><td style={cellStyle}></td>
            </tr>
            {/* Pallet Goal */}
            <tr style={{ borderBottom: '2px solid #000' }}><td style={{ ...cellStyle, textAlign: 'left', position: 'sticky', left: 0, background: '#fff', zIndex: 1 }}>Big Box Pallet Goal</td>
              {allKeys.map(k => <td key={k} style={cellStyle}>{Math.round(getVols(k).pr/cpp)||'—'}</td>)}
              <td style={{ ...cellStyle, fontWeight: 600 }}>{Math.round(siteTotal(k=>getVols(k).pr)/cpp).toLocaleString()}</td><td style={cellStyle}></td>
            </tr>

            {/* Rostered Hours */}
            <tr><td style={{ ...cellStyle, textAlign: "left", position: "sticky", left: 0, background: "#fff", zIndex: 1 }}>Rostered Hours</td>
              {allKeys.map(k => <td key={k} style={{ ...cellStyle, padding: "1px" }}><input type="text" value={rosteredHours[k] || ""} onChange={e => setRosteredHours(prev => ({...prev, [k]: e.target.value}))} style={inputStyle} /></td>)}
              <td style={{ ...cellStyle, fontWeight: 600 }}>{Math.round(siteTotal(k => parseFloat(rosteredHours[k]) || 0)).toLocaleString()}</td><td style={cellStyle}></td>
            </tr>
            {/* Attendance Rate */}
            <tr><td style={{ ...cellStyle, textAlign: "left", position: "sticky", left: 0, background: "#fff", zIndex: 1 }}>Attendance %</td>
              {allKeys.map(k => <td key={k} style={{ ...cellStyle, padding: "1px" }}><input type="text" value={attendanceRate[k] !== undefined ? attendanceRate[k] : ""} onChange={e => setAttendanceRate(prev => ({...prev, [k]: e.target.value}))} style={inputStyle} /></td>)}
              <td style={cellStyle}></td><td style={cellStyle}></td>
            </tr>
            {/* Expected Hours = Rostered x Attendance */}
            <tr><td style={{ ...cellStyle, textAlign: "left", fontWeight: 600, position: "sticky", left: 0, background: "#e3f2fd", zIndex: 1 }}>Expected Hours</td>
              {allKeys.map(k => { const r = parseFloat(rosteredHours[k]) || 0; const a = parseFloat(attendanceRate[k]) || 0; const planned = Math.round(r * a / 100); return <td key={k} style={{ ...cellStyle, fontWeight: 600, background: "#e3f2fd" }}>{planned || ""}</td>; })}
              {(() => { const t = siteTotal(k => Math.round((parseFloat(rosteredHours[k])||0) * (parseFloat(attendanceRate[k])||0) / 100)); return <td style={{ ...cellStyle, fontWeight: 700, background: "#e3f2fd" }}>{t.toLocaleString()}</td>; })()}
              <td style={cellStyle}></td>
            </tr>
            {/* Extra Hours = Expected Hours - (IB + DA Hours) : handled by VET/VTO pre-shift */}
            <tr><td style={{ ...cellStyle, textAlign: 'left', position: 'sticky', left: 0, background: '#fff', zIndex: 1 }}>Extra Hours (+/-)</td>
              {allKeys.map(k => { const planned = Math.round((parseFloat(rosteredHours[k])||0) * (parseFloat(attendanceRate[k])||0) / 100); const actual = getIBHours(k) + getDAHours(k); const d = planned - actual; return <td key={k} style={{ ...cellStyle, color: d>=0?'#4caf50':'#ef5350', fontWeight: 600 }}>{planned ? Math.round(d).toLocaleString() : '—'}</td>; })}
              {(() => { const tp = siteTotal(k => Math.round((parseFloat(rosteredHours[k])||0) * (parseFloat(attendanceRate[k])||0) / 100)); const ta = siteTotal(k => getIBHours(k) + getDAHours(k)); const d = tp - ta; return <td style={{ ...cellStyle, color: d>=0?'#4caf50':'#ef5350', fontWeight: 700 }}>{Math.round(d).toLocaleString()}</td>; })()}
              <td style={cellStyle}></td>
            </tr>
            {/* Planned Hours = Expected +/- Extra = IB + DA (post VET/VTO); drives the MSM tab */}
            <tr><td style={{ ...cellStyle, textAlign: 'left', fontWeight: 700, position: 'sticky', left: 0, background: '#c8e6c9', zIndex: 1, color: '#1b5e20' }}>Planned Hours</td>
              {allKeys.map(k => { const v = getIBHours(k) + getDAHours(k); return <td key={k} style={{ ...cellStyle, fontWeight: 700, background: '#c8e6c9', color: '#1b5e20' }}>{v ? Math.round(v).toLocaleString() : '—'}</td>; })}
              <td style={{ ...cellStyle, fontWeight: 700, background: '#c8e6c9', color: '#1b5e20' }}>{Math.round(siteTotal(k => getIBHours(k) + getDAHours(k))).toLocaleString()}</td>
              <td style={cellStyle}></td>
            </tr>
            {/* IB Hours */}
            <tr><td style={{ ...cellStyle, textAlign: 'left', position: 'sticky', left: 0, background: '#fff', zIndex: 1 }}>IB Hours</td>
              {allKeys.map(k => <td key={k} style={cellStyle}>{Math.round(getIBHours(k)).toLocaleString()||'—'}</td>)}
              <td style={{ ...cellStyle, fontWeight: 600 }}>{Math.round(siteTotal(k=>getIBHours(k))).toLocaleString()}</td><td style={cellStyle}></td>
            </tr>
            {/* DA Hours */}
            <tr style={{ borderBottom: '2px solid #000' }}><td style={{ ...cellStyle, textAlign: 'left', position: 'sticky', left: 0, background: '#fff', zIndex: 1 }}>DA Hours</td>
              {allKeys.map(k => <td key={k} style={cellStyle}>{Math.round(getDAHours(k)).toLocaleString()||'—'}</td>)}
              <td style={{ ...cellStyle, fontWeight: 600 }}>{Math.round(siteTotal(k=>getDAHours(k))).toLocaleString()}</td><td style={cellStyle}></td>
            </tr>
            {/* CPLH rows */}
            <tr><td style={{ ...cellStyle, textAlign: 'left', fontWeight: 700, position: 'sticky', left: 0, background: '#fff3e0', zIndex: 1, color: '#e65100' }}>Production CPLH</td>
              {allKeys.map(k => { const hrs = (shiftData[k]?.hours||0) - ((shiftData[k]?.hours||0) - getRequiredHours(k)); const c = (shiftData[k]?.cartons||0) * 2; return <td key={k} style={{ ...cellStyle, background: '#fff3e0', fontWeight: 600, color: '#e65100' }}>{hrs > 0 ? (c / hrs).toFixed(1) : '—'}</td>; })}
              {(() => { const th = siteTotal(k=>getRequiredHours(k)); const tc = siteTotal(k=>(shiftData[k]?.cartons||0)*2); return <td style={{ ...cellStyle, fontWeight: 700, background: '#fff3e0', color: '#e65100' }}>{th>0?(tc/th).toFixed(1):'—'}</td>; })()}
              <td style={cellStyle}></td>
            </tr>
            <tr><td style={{ ...cellStyle, textAlign: 'left', fontWeight: 600, position: 'sticky', left: 0, background: '#fff', zIndex: 1 }}>IB CPLH</td>
              {allKeys.map(k => { const hrs = getIBHours(k); const c = shiftData[k]?.cartons||0; return <td key={k} style={{ ...cellStyle, fontWeight: 500 }}>{hrs > 0 ? (c / hrs).toFixed(1) : '—'}</td>; })}
              {(() => { const th = siteTotal(k=>getIBHours(k)); const tc = siteTotal(k=>shiftData[k]?.cartons||0); return <td style={{ ...cellStyle, fontWeight: 700 }}>{th>0?(tc/th).toFixed(1):'—'}</td>; })()}
              <td style={cellStyle}></td>
            </tr>
            <tr style={{ borderBottom: '2px solid #000' }}><td style={{ ...cellStyle, textAlign: 'left', fontWeight: 600, position: 'sticky', left: 0, background: '#fff', zIndex: 1 }}>DA CPLH</td>
              {allKeys.map(k => { const hrs = getDAHours(k); const c = shiftData[k]?.cartons||0; return <td key={k} style={{ ...cellStyle, fontWeight: 500 }}>{hrs > 0 ? (c / hrs).toFixed(1) : '—'}</td>; })}
              {(() => { const th = siteTotal(k=>getDAHours(k)); const tc = siteTotal(k=>shiftData[k]?.cartons||0); return <td style={{ ...cellStyle, fontWeight: 700 }}>{th>0?(tc/th).toFixed(1):'—'}</td>; })()}
              <td style={cellStyle}></td>
            </tr>

            {/* Admin Hours (auto-summed from detail table) */}
            <tr><td style={{ ...cellStyle, textAlign: 'left', fontWeight: 600, position: 'sticky', left: 0, background: '#fff3e0', zIndex: 1 }}>Admin Hours ↓</td>
              {allKeys.map(k => <td key={k} style={{ ...cellStyle, fontWeight: 600, background: '#fff3e0', color: '#e65100' }}>{parseFloat(adminHours[k]) > 0 ? parseFloat(adminHours[k]).toFixed(1) : ''}</td>)}
              <td style={{ ...cellStyle, fontWeight: 700, background: '#fff3e0', color: '#e65100' }}>{Math.round(siteTotal(k => parseFloat(adminHours[k]) || 0)).toLocaleString()}</td>
              <td style={{ ...cellStyle, background: '#fff3e0', fontSize: '0.45rem', color: '#999' }}>auto</td>
            </tr>
            {/* Diluted CPLH = cartons*2 / (IB + DA + Admin Hours) */}
            <tr style={{ borderBottom: '2px solid #000' }}><td style={{ ...cellStyle, textAlign: 'left', fontWeight: 700, position: 'sticky', left: 0, background: '#e8eaf6', zIndex: 1, color: '#283593' }}>Diluted CPLH</td>
              {allKeys.map(k => { const c = (shiftData[k]?.cartons||0) * 2; const hrs = getIBHours(k) + getDAHours(k) + (parseFloat(adminHours[k])||0); return <td key={k} style={{ ...cellStyle, fontWeight: 700, background: '#e8eaf6', color: '#283593' }}>{hrs > 0 ? (c / hrs).toFixed(1) : '—'}</td>; })}
              {(() => { const tc = siteTotal(k=>(shiftData[k]?.cartons||0)*2); const th = siteTotal(k=>getIBHours(k)+getDAHours(k)+(parseFloat(adminHours[k])||0)); return <td style={{ ...cellStyle, fontWeight: 700, background: '#e8eaf6', color: '#283593' }}>{th>0?(tc/th).toFixed(1):'—'}</td>; })()}
              <td style={cellStyle}></td>
            </tr>
            {/* Q3G Target: Finance-locked diluted CPLH (PPID 609) for this week — reference only, with per-shift delta */}
            {q3gTargetDiluted > 0 && (
              <tr style={{ borderBottom: '2px solid #000' }}><td style={{ ...cellStyle, textAlign: 'left', fontWeight: 700, position: 'sticky', left: 0, background: '#e8f5e9', zIndex: 1, color: '#1b5e20' }}>Q3G Target CPLH</td>
                {allKeys.map(k => { const c = (shiftData[k]?.cartons||0) * 2; const hrs = getIBHours(k) + getDAHours(k) + (parseFloat(adminHours[k])||0); const act = hrs > 0 ? c / hrs : 0; const d = act - q3gTargetDiluted; const color = act <= 0 ? '#999' : (Math.abs(d) <= 0.5 ? '#1b5e20' : (d < 0 ? '#c62828' : '#1565c0')); return <td key={k} style={{ ...cellStyle, background: '#e8f5e9', color, fontWeight: 600 }} title={act > 0 ? `Diluted ${act.toFixed(1)} vs target ${q3gTargetDiluted.toFixed(1)} (${d >= 0 ? '+' : ''}${d.toFixed(1)})` : 'No plan for this shift'}>{act > 0 ? q3gTargetDiluted.toFixed(1) : '—'}</td>; })}
                <td style={{ ...cellStyle, fontWeight: 700, background: '#e8f5e9', color: '#1b5e20' }}>{q3gTargetDiluted.toFixed(1)}</td>
                <td style={{ ...cellStyle, background: '#e8f5e9', fontSize: '0.45rem', color: '#999' }}>Wk {q3gWeekKey(weekStart)}</td>
              </tr>
            )}

            {/* Dept sections */}
            {DEPTS.map(dept => (
              <React.Fragment key={dept.id}>
                {/* Dept Rate */}
                <tr style={{ background: '#e8f5e9' }}><td style={{ ...cellStyle, textAlign: 'left', fontWeight: 700, color: '#1b5e20', position: 'sticky', left: 0, background: '#e8f5e9', zIndex: 1 }}>{dept.name} Rate <button onClick={() => recomputeDeptFromVolume(dept)} title={`Recompute all ${dept.name} functions from volume ÷ loaded rate (clears this path's hours/rate overrides)`} style={{ fontSize: '0.5rem', cursor: 'pointer', border: '1px solid #1b5e20', borderRadius: 2, padding: '0 3px', marginLeft: 4, background: '#fff', color: '#1b5e20' }}>↻</button></td>
                  {allKeys.map(k => <td key={k} style={{ ...cellStyle, padding: '1px', background: '#e8f5e9' }}><input type="text" value={overrides[dept.id]?.rate?.[k] !== undefined ? overrides[dept.id].rate[k] : (getDeptRate(dept,k)?getDeptRate(dept,k).toFixed(1):'')} onChange={e => { const val = e.target.value; setOverride(dept.id,'rate',k,val); const r = parseFloat(val); if (r > 0) { const vols = getVols(k); const vol = vols[dept.volKey]||0; if (vol > 0) setOverride(dept.id,'hours',k,String(Math.round(vol/r))); } else if (val === '') { setOverride(dept.id,'hours',k,''); } }} style={{ ...inputStyle, color: '#1b5e20', fontWeight: 600 }} /></td>)}
                  {(() => { const tv=siteTotal(k=>getVols(k)[dept.volKey]||0); const th=siteTotal(k=>getDeptHours(dept,k)); return <td style={{ ...cellStyle, fontWeight:700, background:'#e8f5e9' }}>{th>0?(tv/th).toFixed(1):'—'}</td>; })()}
                  <td style={{ ...cellStyle, background: '#e8f5e9' }}><button onClick={() => { const v = overrides[dept.id]?.rate?.[allKeys[0]] || (getDeptRate(dept,allKeys[0])?getDeptRate(dept,allKeys[0]).toFixed(1):''); allKeys.forEach(k => { setOverride(dept.id,'rate',k,v); const r = parseFloat(v); if (r > 0) { const vols = getVols(k); const vol = vols[dept.volKey]||0; if (vol > 0) setOverride(dept.id,'hours',k,String(Math.round(vol/r))); } }); }} style={{ fontSize:'0.5rem', cursor:'pointer', border:'1px solid #ccc', borderRadius:2, padding:'1px 4px' }}>⟹</button></td>
                </tr>
                {/* Dept Hours */}
                <tr style={{ background: '#e3f2fd' }}><td style={{ ...cellStyle, textAlign: 'left', fontWeight: 700, color: '#1565c0', position: 'sticky', left: 0, background: '#e3f2fd', zIndex: 1 }}>{dept.name} Hours</td>
                  {allKeys.map(k => <td key={k} style={{ ...cellStyle, padding: '1px', background: '#e3f2fd' }}><input type="text" value={overrides[dept.id]?.hours?.[k] !== undefined ? overrides[dept.id].hours[k] : (getDeptHours(dept,k)?Math.round(getDeptHours(dept,k)):'')} onChange={e => { const val = e.target.value; setOverride(dept.id,'hours',k,val); const h = parseFloat(val); if (h > 0) { const vols = getVols(k); const vol = vols[dept.volKey]||0; if (vol > 0) setOverride(dept.id,'rate',k,(vol/h).toFixed(1)); } else if (val === '') { setOverride(dept.id,'rate',k,''); } }} style={{ ...inputStyle, color: '#1565c0', fontWeight: 600 }} /></td>)}
                  <td style={{ ...cellStyle, fontWeight:700, background:'#e3f2fd' }}>{Math.round(siteTotal(k=>getDeptHours(dept,k))).toLocaleString()}</td>
                  <td style={{ ...cellStyle, background: '#e3f2fd' }}><button onClick={() => { const v = overrides[dept.id]?.hours?.[allKeys[0]] || (getDeptHours(dept,allKeys[0])?Math.round(getDeptHours(dept,allKeys[0])):''); allKeys.forEach(k => { setOverride(dept.id,'hours',k,String(v)); const h = parseFloat(v); if (h > 0) { const vols = getVols(k); const vol = vols[dept.volKey]||0; if (vol > 0) setOverride(dept.id,'rate',k,(vol/h).toFixed(1)); } }); }} style={{ fontSize:'0.5rem', cursor:'pointer', border:'1px solid #ccc', borderRadius:2, padding:'1px 4px' }}>⟹</button></td>
                </tr>
                {/* Function rows */}
                {dept.functions.map(({ casual, fn }) => (
                  <React.Fragment key={fn+casual}>
                    <tr><td style={{ ...cellStyle, textAlign: 'left', paddingLeft: 12, fontSize: '0.6rem', position: 'sticky', left: 0, background: '#fff', zIndex: 1 }}>{casual} Rate</td>
                      {allKeys.map(k => <td key={k} style={{ ...cellStyle, padding: '1px' }}><input type="text" value={overrides[fn]?.rate?.[k] !== undefined ? overrides[fn].rate[k] : (getFnRate(fn, k, dept)?getFnRate(fn, k, dept).toFixed(1):'')} onChange={e => { const val = e.target.value; setOverride(fn,'rate',k,val); const r = parseFloat(val); if (r > 0) { const vols = getVols(k); const fnVolKey = resolveFnVolKey(fn, dept); const vol = fn === '_line_palletReceive' ? (vols.pr||0)/cpp : (vols[fnVolKey]||vols[dept.volKey]||0); if (vol > 0) setOverride(fn,'hours',k,String(Math.round(vol/r))); } else if (val === '') { setOverride(fn,'hours',k,''); } }} style={{ ...inputStyle, fontSize: '0.6rem' }} /></td>)}
                      {(() => { const tv=siteTotal(k=>getVols(k)[dept.volKey]||0); const th=siteTotal(k=>getFnHours(fn,dept,k)); return <td style={{ ...cellStyle, fontSize:'0.6rem' }}>{th>0?(tv/th).toFixed(1):'—'}</td>; })()}
                      <td style={cellStyle}><button onClick={() => { const v = overrides[fn]?.rate?.[allKeys[0]] || (getFnRate(fn,allKeys[0])?getFnRate(fn,allKeys[0]).toFixed(1):''); allKeys.forEach(k => { setOverride(fn,'rate',k,v); const r = parseFloat(v); if (r > 0) { const vols = getVols(k); const fnVolKey = resolveFnVolKey(fn, dept); const vol = fn === '_line_palletReceive' ? (vols.pr||0)/cpp : (vols[fnVolKey]||vols[dept.volKey]||0); if (vol > 0) setOverride(fn,'hours',k,String(Math.round(vol/r))); } }); }} style={{ fontSize:'0.5rem', cursor:'pointer', border:'1px solid #ccc', borderRadius:2, padding:'1px 4px' }}>⟹</button></td>
                    </tr>
                    <tr style={{ borderBottom: '1px solid #eee' }}><td style={{ ...cellStyle, textAlign: 'left', paddingLeft: 12, fontSize: '0.6rem', color: '#666', position: 'sticky', left: 0, background: '#fff', zIndex: 1 }}>{casual} Hours</td>
                      {allKeys.map(k => <td key={k} style={{ ...cellStyle, padding: '1px' }}><input type="text" value={overrides[fn]?.hours?.[k] !== undefined ? overrides[fn].hours[k] : (getFnHours(fn,dept,k)?Math.round(getFnHours(fn,dept,k)):'')} onChange={e => { const val = e.target.value; setOverride(fn,'hours',k,val); const h = parseFloat(val); if (h > 0) { const vols = getVols(k); const fnVolKey = resolveFnVolKey(fn, dept); const vol = fn === '_line_palletReceive' ? (vols.pr||0)/cpp : (vols[fnVolKey]||vols[dept.volKey]||0); if (vol > 0) setOverride(fn,'rate',k,(vol/h).toFixed(1)); } else if (val === '') { setOverride(fn,'rate',k,''); } }} style={{ ...inputStyle, fontSize: '0.6rem', color: '#666' }} /></td>)}
                      <td style={{ ...cellStyle, fontSize:'0.6rem' }}>{Math.round(siteTotal(k=>getFnHours(fn,dept,k))).toLocaleString()}</td>
                      <td style={cellStyle}><button onClick={() => { const v = overrides[fn]?.hours?.[allKeys[0]] || (getFnHours(fn,dept,allKeys[0])?Math.round(getFnHours(fn,dept,allKeys[0])):''); allKeys.forEach(k => { setOverride(fn,'hours',k,String(v)); const h = parseFloat(v); if (h > 0) { const vols = getVols(k); const fnVolKey = resolveFnVolKey(fn, dept); const vol = fn === '_line_palletReceive' ? (vols.pr||0)/cpp : (vols[fnVolKey]||vols[dept.volKey]||0); if (vol > 0) setOverride(fn,'rate',k,(vol/h).toFixed(1)); } }); }} style={{ fontSize:'0.5rem', cursor:'pointer', border:'1px solid #ccc', borderRadius:2, padding:'1px 4px' }}>⟹</button></td>
                    </tr>
                  </React.Fragment>
                ))}
              </React.Fragment>
            ))}
            {/* EOL % row at bottom */}
            <tr style={{ borderTop: '2px solid #000' }}><td style={{ ...cellStyle, textAlign: 'left', fontWeight: 700, position: 'sticky', left: 0, background: '#fff3e0', zIndex: 1, color: '#e65100' }}>EOL % (of PID)</td>
              {allKeys.map(k => <td key={k} style={{ ...cellStyle, background: '#fff3e0', color: '#e65100', fontWeight: 600 }}>{eolPct}%</td>)}
              <td style={{ ...cellStyle, padding: '1px', background: '#fff3e0' }}><input type="text" value={eolPct} onChange={e => setEolPct(parseFloat(e.target.value) || 0)} style={{ ...inputStyle, color: '#e65100', fontWeight: 700, background: '#fff3e0', border: '2px solid #e65100', borderRadius: 3 }} /></td>
              <td style={cellStyle}></td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* Admin Hours Detail */}
      <div className="card" style={{ marginTop: 16 }}>
        <details open>
          <summary style={{ cursor: "pointer", fontWeight: 700, fontSize: "0.85rem" }}>📋 Admin Hours Detail (Editable — Auto-Sums to Admin Hours Row)</summary>
          <div style={{ overflowX: "auto", marginTop: 8 }}>
            <table style={{ borderCollapse: "collapse", fontSize: "0.6rem", width: 'max-content' }}>
              <thead>
                <tr>
                  <th style={{ ...headerStyle, textAlign: 'left', minWidth: 130, position: 'sticky', left: 0, zIndex: 2, background: '#1a3a5c' }}></th>
                  <th colSpan={7} style={{ ...headerStyle, background: '#1a3a5c' }}>Days</th>
                  <th colSpan={7} style={{ ...headerStyle, background: '#0d47a1' }}>Nights</th>
                  <th style={{ ...headerStyle, background: '#333' }}>Site Total</th>
                  <th style={{ ...headerStyle, background: '#666', fontSize: '0.55rem' }}>Copy</th>
                </tr>
                <tr>
                  <th style={{ ...headerStyle, textAlign: 'left', position: 'sticky', left: 0, zIndex: 2, background: '#1a3a5c' }}></th>
                  {DAYS.map(d => <th key={d+'d'} style={headerStyle}>{d.slice(0,3)}</th>)}
                  {DAYS.map(d => <th key={d+'n'} style={{ ...headerStyle, background: '#0d47a1' }}>{d.slice(0,3)}</th>)}
                  <th style={{ ...headerStyle, background: '#333' }}>Total</th>
                  <th style={{ ...headerStyle, background: '#666', fontSize: '0.5rem' }}>→All</th>
                </tr>
              </thead>
              <tbody>
                {ADMIN_CATEGORIES.map(cat => (
                  <React.Fragment key={cat.label}>
                    {/* Category header */}
                    <tr><td colSpan={allKeys.length + 3} style={{ ...cellStyle, textAlign: "left", fontWeight: 700, fontSize: "0.65rem", background: cat.color, borderTop: "2px solid #666", padding: "4px 6px" }}>{cat.label}</td></tr>
                    {/* Function rows */}
                    {cat.functions.map(fn => {
                      const vals = adminDetail[fn] || {};
                      const rowTotal = allKeys.reduce((s, k) => s + (parseFloat(vals[k]) || 0), 0);
                      return (
                        <tr key={fn} style={{ background: cat.color }}>
                          <td style={{ ...cellStyle, textAlign: "left", position: "sticky", left: 0, background: cat.color, zIndex: 1, fontSize: "0.6rem", padding: "1px 3px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", minWidth: 130 }} title={fn}>{fn}</td>
                          {allKeys.map(k => (
                            <td key={k} style={{ ...cellStyle, padding: "1px", background: cat.color }}>
                              <input
                                type="text"
                                value={vals[k] !== undefined ? vals[k] : ''}
                                onChange={e => {
                                  const v = e.target.value;
                                  setAdminDetail(prev => ({
                                    ...prev,
                                    [fn]: { ...(prev[fn] || {}), [k]: v === '' ? '' : v }
                                  }));
                                }}
                                style={inputStyle}
                              />
                            </td>
                          ))}
                          <td style={{ ...cellStyle, fontWeight: 600, background: cat.color }}>{rowTotal.toFixed(1)}</td>
                          <td style={{ ...cellStyle, background: cat.color }}>
                            <button onClick={() => {
                              const firstDay = vals[allKeys[0]] || '';
                              const firstNight = vals[DAYS[0] + '_night'] || firstDay;
                              const updated = { ...(adminDetail[fn] || {}) };
                              dayKeys.forEach(k => { updated[k] = firstDay; });
                              nightKeys.forEach(k => { updated[k] = firstNight; });
                              setAdminDetail(prev => ({ ...prev, [fn]: updated }));
                            }} style={{ fontSize: '0.45rem', cursor: 'pointer', border: '1px solid #ccc', borderRadius: 2, padding: '0px 3px', background: '#fff' }}>⟹</button>
                          </td>
                        </tr>
                      );
                    })}
                    {/* Category subtotal */}
                    <tr style={{ borderBottom: "1px solid #999" }}>
                      <td style={{ ...cellStyle, textAlign: "left", fontWeight: 700, position: "sticky", left: 0, background: cat.color, zIndex: 1, borderTop: "1px solid #999", minWidth: 130 }}>{cat.label} Total</td>
                      {allKeys.map(k => {
                        const catTotal = cat.functions.reduce((s, fn) => s + (parseFloat(adminDetail[fn]?.[k]) || 0), 0);
                        return <td key={k} style={{ ...cellStyle, fontWeight: 700, background: cat.color, borderTop: "1px solid #999" }}>{catTotal > 0 ? catTotal.toFixed(1) : ''}</td>;
                      })}
                      <td style={{ ...cellStyle, fontWeight: 700, background: cat.color, borderTop: "1px solid #999" }}>
                        {cat.functions.reduce((s, fn) => s + allKeys.reduce((s2, k) => s2 + (parseFloat(adminDetail[fn]?.[k]) || 0), 0), 0).toFixed(1)}
                      </td>
                      <td style={{ ...cellStyle, background: cat.color }}></td>
                    </tr>
                  </React.Fragment>
                ))}
                {/* Grand total row */}
                <tr style={{ borderTop: "3px solid #000" }}>
                  <td style={{ ...cellStyle, textAlign: "left", fontWeight: 700, position: "sticky", left: 0, background: "#e8eaf6", zIndex: 1, minWidth: 130 }}>GRAND TOTAL</td>
                  {allKeys.map(k => {
                    const grandTotal = ADMIN_CATEGORIES.reduce((s, cat) => s + cat.functions.reduce((s2, fn) => s2 + (parseFloat(adminDetail[fn]?.[k]) || 0), 0), 0);
                    return <td key={k} style={{ ...cellStyle, fontWeight: 700, background: "#e8eaf6" }}>{grandTotal > 0 ? grandTotal.toFixed(1) : ''}</td>;
                  })}
                  <td style={{ ...cellStyle, fontWeight: 700, background: "#e8eaf6" }}>
                    {ADMIN_CATEGORIES.reduce((s, cat) => s + cat.functions.reduce((s2, fn) => s2 + allKeys.reduce((s3, k) => s3 + (parseFloat(adminDetail[fn]?.[k]) || 0), 0), 0), 0).toFixed(0)}
                  </td>
                  <td style={{ ...cellStyle, background: "#e8eaf6" }}></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: 8, fontSize: "0.7rem", color: "#666" }}>
            <strong>Tip:</strong> Edit any cell — totals auto-feed the Admin Hours row above. Use ⟹ to copy Sunday Day/Night values across all days/nights.
          </div>
        </details>
      </div>
    </div>
  );
}
